<template>
    <div>
        <h1>SAD ! 404 not Found ! cette url n'existe pas ! comme c'est dommage</h1>
    </div>
</template>